import { notify } from './notify.js';

/** What the user is told when the browser refuses the clipboard, or has none to offer. */
const CLIPBOARD_UNAVAILABLE = 'Clipboard unavailable';

/**
 * Copy one value to the clipboard and say what happened — the toast idiom the decks and the share dialog
 * already use, lifted out of them so a new copy button cannot invent a third wording.
 *
 * It never rejects. Writing to the clipboard fails for reasons that have nothing to do with the caller —
 * a denied permission, an insecure origin, a browser with no clipboard API — and every one of them ends
 * as a toast the user can read rather than an unhandled rejection. The returned flag says whether the
 * value actually reached the clipboard, so a caller with something to add about what it just copied can
 * hold that back when nothing was copied.
 */
export async function copyToClipboard(
  value: string,
  successMessage: string,
): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(value);
    notify.success(successMessage);
    return true;
  } catch {
    notify.error(CLIPBOARD_UNAVAILABLE);
    return false;
  }
}
